/**
 *
 * @param {string} name
 * @returns
 */

const API = `app`;

export const LOAD_RECORDS_PROJECT_CACHE = `${API}/LOAD_RECORDS_PROJECT_CACHE`

export const LOAD_PROJECT_DETAILS = `${API}/LOAD_PROJECT_DETAILS`;
export const LOAD_PROJECT_SUCCESS = `${API}/LOAD_PROJECT_SUCCESS`;
export const LOAD_PROJECT_ERROR = `${API}/LOAD_PROJECT_ERROR`;

export const LOAD_PHASE_DETAILS = `${API}/LOAD_PHASE_DETAILS`;
export const LOAD_PHASE_SUCCESS = `${API}/LOAD_PHASE_SUCCESS`;
export const LOAD_PHASE_ERROR = `${API}/LOAD_PHASE_ERROR`;

export const LOAD_DROPDOWN_PROJECT = `${API}/LOAD_DROPDOWN_PROJECT`;
export const LOAD_DROPDOWN_PROJECT_SUCCESS = `${API}/LOAD_DROPDOWN_PROJECT_SUCCESS`;
export const LOAD_DROPDOWN_PROJECT_ERROR = `${API}/LOAD_DROPDOWN_PROJECT_ERROR`;

const constants = {
    LOAD_PROJECT_DETAILS,
    LOAD_PROJECT_SUCCESS,
    LOAD_PROJECT_ERROR,

    LOAD_PHASE_DETAILS,
    LOAD_PHASE_SUCCESS,
    LOAD_PHASE_ERROR,
   
    LOAD_DROPDOWN_PROJECT,
    LOAD_DROPDOWN_PROJECT_SUCCESS,
    LOAD_DROPDOWN_PROJECT_ERROR,

    LOAD_RECORDS_PROJECT_CACHE
}


export default constants;